import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const ResultsResource = () => {
  return Vue.resource('teacher{/idTeacher}/results')
}



// WEBPACK FOOTER //
// ./src/api/results.js